<yat-wallet-button
  [walletButtonTextMode]="'CONTINUE'"
  [activeWallet]="activeWallet"
  [paymentActionFilter]="connectActionFilter"
  [pricingInformation]="pricingInformation$ | async"
  [debitDate]="endOfPeriod$ | async"
  [vendorName]="(vendorName$ | async) ?? ''"
  [businessModel]="(businessModel$ | async) ?? 'B2B'"
  [walletButtonEnvironment]="(isLive$ | async) && isProduction ? 'LIVE' : 'TEST'"
  (walletPaymentSuccessful)="onWalletPayment($event)"></yat-wallet-button>
